export default __webpack_public_path__ + "static/media/pictogramBeaconDocument64.27454fdb.svg";